import { useDebounce } from "@resamare/react-hooks";
import { useEffect } from "react";
import { useWatch } from "react-hook-form";

type AutoSubmitProps = {
    delay: number;
    onSubmit: () => void;
};

export function AutoSubmit({ delay, onSubmit }: AutoSubmitProps) {
    const watchedValues = useWatch();

    const debouncedValues = useDebounce(watchedValues, delay);

    useEffect(() => {
        if (onSubmit) {
            onSubmit();
        }
    }, [debouncedValues]);

    return null;
}
